import { render, staticRenderFns } from "./addTank.vue?vue&type=template&id=bd92b4bc&scoped=true&"
import script from "./addTank.vue?vue&type=script&lang=ts&"
export * from "./addTank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd92b4bc",
  null
  
)

export default component.exports